:host {
  --back-to-top--background-color: linear-gradient(90deg, rgba(209,190,124,1) 0%, rgba(186,149,90,1) 100%);
  --back-to-top--color: #fff;
  --back-to-top--padding: 10px 20px;
  --back-to-top--border-radius: 6px 0px 0px 6px;
  --back-to-top--bottom: 20px;
  --back-to-top--right: 0px;
  --back-to-top--font-size: 16px;
  --back-to-top--z-index: 1000;
  --back-to-top--border: none;

  display: block
}

.back-to-top {
  position: fixed;
  bottom: var(--back-to-top--bottom);
  right: var(--back-to-top--right);

  background: var(--back-to-top--background-color);
  color: var(--back-to-top--color);

  padding: var(--back-to-top--padding);
  border: var(--back-to-top--border);
  border-radius: var(--back-to-top--border-radius);
  font-size: var(--back-to-top--font-size);
  cursor: pointer;

  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  z-index: var(--back-to-top--z-index);
}

.back-to-top--visible {
  opacity: 1;
  visibility: visible;
}

